'use client';

import { Suspense } from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy';
import PrivacyPolicySkeleton from '../components/PrivacyPolicySkeleton';
import type { PrivacyPolicyData } from '@/types/privacy-policy';

interface PrivacyPolicyClientProps {
  locale: string;
  data: PrivacyPolicyData | null;
}

export default function PrivacyPolicyClient({ locale, data }: PrivacyPolicyClientProps) {
  return (
    <Suspense fallback={<PrivacyPolicySkeleton />}>
      <PrivacyPolicy locale={locale} data={data} />
    </Suspense>
  );
}
